// Duck Energy brand: darkLogo (black) shows on the light theme, lightLogo (white) on dark.
import darkLogo from 'assets/img/duckEnergyLogo.svg';
import lightLogo from 'assets/img/duckEnergyLogoWhite.svg';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { getItemFromStore } from 'helpers/utils';

const Logo = ({ at, width, className, logoClassName, ...rest }) => {
  const isDarkTheme = getItemFromStore('isDark');

  const logoSrc = useMemo(() => {
    return isDarkTheme ? lightLogo : darkLogo;
  }, [isDarkTheme]);

  return (
    <Link
      to="/dashboard"
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center':
              at === 'navbar-vertical' || at === 'navbar-top',
            'flex-center fw-bolder fs-4': at === 'auth'
          },
          className
        )}
      >
        <img
          className={classNames('measureLogo', logoClassName)}
          src={logoSrc}
          alt="Duck Energy"
          width={width}
        />
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textclass: PropTypes.string,
  logoClassName: PropTypes.string
};

Logo.defaultProps = { at: 'auth', width: 58 };

export default Logo;
